import { pushEventInfo, pushPageErrorInfo } from '../analytics';
import { FULFILLMENT_TYPE } from '../../constants/status';

const buildFulfillmentTypeSettings = (fulfillmentType?: string): string => {
  const map: Record<string, string> = {
    ShipToHome: 'sth',
    BuyOnlineShipToStore: 'boss',
    BuyOnlinePickupInStore: 'bopis',
    BuyOnlineDeliverFromStore: 'bodfs',
    Appliance: 'appl',
    DFS: 'unknown',
    DirectDelivery: 'unknown',
    WillCallFulfillment: 'unknown',
    MISC: 'unknown',
    CanceledItems: 'unknown',
    Additional: 'unknown',
    InStorePurchase: 'unknown',
    Returned: 'unknown',
  };

  const active = map[fulfillmentType ?? ''] ?? 'unknown';
  const keys = ['sth', 'boss', 'bopis', 'bodfs', 'appl', 'unknown'];

  return (
    'orders:' +
    keys.map((key) => `${key}:${key === active ? 'y' : 'n'}`).join('|')
  );
};

export const TrackEditDeliveryAddressAnalytics = (
  settings: string,
  category: 'button submission' | 'overlay',
  fulfillmentType?: FULFILLMENT_TYPE,
) => {
  pushEventInfo({
    category: { primaryCategory: category },
    eventInfo: { eventName: 'my account settings' },
    myAccount: {
      settings,
    },
    ...(fulfillmentType && {
      fulfillmentType: buildFulfillmentTypeSettings(fulfillmentType),
    }),
  });
};

export const TrackErrorPageEditDeliveryAddressAnalytics = (
  pageSection: string,
  message: string,
  code = 'n/a',
) => {
  const pageError = {
    type: 'system',
    displayType: 'inline',
    pageSection,
    message,
    code,
  };
  pushPageErrorInfo(pageError);
};

export const TrackErrorEventEditDeliveryAddressAnalytics = (
  pageSection: string,
  errCode: string,
  errMessage: string,
  type: 'system' | 'error' | 'advisory',
  displayType = 'inline',
) => {
  pushEventInfo({
    category: {
      primaryCategory: 'error',
    },
    eventInfo: {
      eventName: 'post page error',
      error: [
        {
          type,
          displayType,
          pageSection,
          code: errCode,
          message: errMessage,
        },
      ],
    },
  });
};
